<template>
  <div>
    <cx-padding
      :paddingTypeFlag.sync="paddingType"
      :padding.sync="padding"
      :paddingTop.sync="paddingTop"
      :paddingRight.sync="paddingRight"
      :paddingBottom.sync="paddingBottom"
      :paddingLeft.sync="paddingLeft"
    />
    <!--添加外边距-->
    <cx-padding
      class="mt16"
      :paddingTypeFlag.sync="colMarginTypeFlag"
      :padding.sync="colMargin"
      :paddingTop.sync="colMarginTop"
      :paddingRight.sync="colMarginRight"
      :paddingBottom.sync="colMarginBottom"
      :paddingLeft.sync="colMarginLeft"
      paddingName="外边距"
      :sliderMax="100"
    />
  </div>
</template>

<script>
import { historyCombineWrap, historyIgnoreWrap } from "utils/revork"
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    isLastCol: {
      type: Boolean
    }
  },
  data() {
    return {
      offsetWdith: 0
    }
  },
  mounted() {
    this.getWidth()
  },
  computed: {
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$emit("update", "padding", newVal)
          this.$emit("update", "paddingTop", newVal)
          this.$emit("update", "paddingLeft", newVal)
          this.$emit("update", "paddingRight", newVal)
          this.$emit("update", "paddingBottom", newVal)
        })()
      }
    },
    paddingType: {
      get() {
        return this.options.paddingType === "global" || this.options.paddingType === 1 ? 1 : 2
      },
      set(newVal) {
        if (newVal === this.paddingType) return
        this.$emit("update", "paddingType", newVal)
      }
    },
    paddingEdge: {
      get() {
        const data = this.options //获取数据
        const dataMap = ["paddingTop", "paddingLeft", "paddingRight", "paddingBottom"] //过滤工具数组
        return (
          data &&
          parseInt(
            dataMap.reduce((prevK, currK, currKIndex) => {
              if (currKIndex - 1 === 0) {
                return Number(data[prevK]) + Number(data[currK])
              } else {
                return prevK + Number(data[currK])
              }
            }) / dataMap.length
          )
        )
      },
      set(newVal) {
        historyCombineWrap(() => {
          if (newVal === this.paddingEdge) return
          const padding = {
            paddingTop: Number(newVal),
            paddingLeft: Number(newVal),
            paddingRight: Number(newVal),
            paddingBottom: Number(newVal)
          }
          Object.keys(padding).forEach(k => {
            this.$emit("update", k, padding[k])
          })
        })()
      }
    },
    paddingLeft: {
      get() {
        return this.hasProperty(this.options, "paddingLeft")
      },
      set(newVal) {
        if (newVal === this.paddingLeft) return
        this.$emit("update", "paddingLeft", newVal)
      }
    },
    paddingTop: {
      get() {
        return this.hasProperty(this.options, "paddingTop")
      },
      set(newVal) {
        if (newVal === this.paddingTop) return
        this.$emit("update", "paddingTop", newVal)
      }
    },
    paddingRight: {
      get() {
        return this.hasProperty(this.options, "paddingRight")
      },
      set(newVal) {
        if (newVal === this.paddingRight) return
        this.$emit("update", "paddingRight", newVal)
      }
    },
    paddingBottom: {
      get() {
        return this.hasProperty(this.options, "paddingBottom")
      },
      set(newVal) {
        if (newVal === this.paddingBottom) return
        this.$emit("update", "paddingBottom", newVal)
      }
    },
    colMarginTypeFlag: {
      get() {
        historyIgnoreWrap(() => {
          if (this.isLastCol && !this.options.hasOwnProperty("colMargin")) {
            if (this.paddingType === 2) {
              this.$emit("update", "colMargin", [
                this.paddingTop,
                this.paddingRight,
                this.paddingBottom,
                this.paddingLeft
              ])
            } else {
              let colMargin
              // 兼容以前padding 和paddingTop未同步的情况 但是展示的时候仍然使用paddingTop来渲染的
              if (!Array.isArray(this.padding) && this.padding !== this.paddingTop) {
                colMargin = [this.paddingTop, this.paddingRight, this.paddingBottom, this.paddingLeft]
              } else {
                colMargin = Array.isArray(this.padding)
                  ? this.padding
                  : [this.padding, this.padding, this.padding, this.padding]
              }
              this.$emit("update", "colMargin", colMargin)
            }
            this.$emit("update", "colMarginTypeFlag", this.paddingType)
            this.$emit("update", "padding", 0)
            this.$emit("update", "paddingTop", 0)
            this.$emit("update", "paddingLeft", 0)
            this.$emit("update", "paddingRight", 0)
            this.$emit("update", "paddingBottom", 0)
            return this.paddingType
          }
          // 做背景，边框，投影等的旧数据兼容， 将内边距和外边距合并
          if (this.isLastCol && !this.options.hasOwnProperty("mergeMarginPadding")) {
            this.$emit("update", "colMargin", [
              this.paddingTop + this.colMarginTop,
              this.paddingRight + this.colMarginRight,
              this.paddingBottom + this.colMarginBottom,
              this.paddingLeft + this.colMarginLeft
            ])
            this.$emit("update", "colMarginTypeFlag", 2)
            this.$emit("update", "padding", 0)
            this.$emit("update", "paddingTop", 0)
            this.$emit("update", "paddingLeft", 0)
            this.$emit("update", "paddingRight", 0)
            this.$emit("update", "paddingBottom", 0)
            this.$emit("update", "mergeMarginPadding", true)
          }
        })()
        return this.options.colMarginTypeFlag || 1
      },
      set(newVal) {
        historyCombineWrap(() => {
          if (newVal === 1) {
            this.$emit("update", "colMargin", [
              this.colMarginTop,
              this.colMarginTop,
              this.colMarginTop,
              this.colMarginTop
            ])
          }
          this.$emit("update", "colMarginTypeFlag", newVal)
        })()
      }
    },
    colMargin: {
      get() {
        if (!this.options.colMargin) {
          historyIgnoreWrap(() => {
            this.$emit("update", "colMargin", [0, 0, 0, 0])
          })()
        }
        return this.options.colMargin ? this.options.colMargin[0] : 0
      },
      set(newVal) {
        this.$emit("update", "colMargin", [newVal, newVal, newVal, newVal])
      }
    },
    colMarginTop: {
      get() {
        return this.options.colMargin ? this.options.colMargin[0] : 0
      },
      set(newVal) {
        this.$emit("update", "colMargin.0", newVal)
      }
    },
    colMarginRight: {
      get() {
        return this.options.colMargin ? this.options.colMargin[1] : 0
      },
      set(newVal) {
        this.$emit("update", "colMargin.1", newVal)
      }
    },
    colMarginBottom: {
      get() {
        return this.options.colMargin ? this.options.colMargin[2] : 0
      },
      set(newVal) {
        this.$emit("update", "colMargin.2", newVal)
      }
    },
    colMarginLeft: {
      get() {
        return this.options.colMargin ? this.options.colMargin[3] : 0
      },
      set(newVal) {
        this.$emit("update", "colMargin.3", newVal)
      }
    }
  },
  methods: {
    getWidth() {
      requestAnimationFrame(() => {
        const width = this.$el.offsetWidth
        if (!!width) {
          this.offsetWdith = width
        } else {
          this.getWidth()
        }
      })
    }
  }
}
</script>

<style scoped>
.clearFloat {
  clear: both;
}
</style>
